import {cdmMw} from '../api';

export default {
    api: cdmMw,
    url: 'api/desklog/actions',
    useCache: false,
    parseResponse: ({data}) => data,
    defaultValue: []
};
